import React from 'react';

interface CheckBoxProps {
  id: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  label?: string;
  name?: string;
  labelClassName?: string;
  disabled?: boolean;
  containerStyles?: React.CSSProperties;
  defaultChecked?: boolean;
}

const CheckBox: React.FunctionComponent<CheckBoxProps> = (props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(e.target.checked);
  };

  return (
    <div style={props.containerStyles}>
      <input
        type="checkbox"
        id={props.id}
        name={props.name}
        checked={props.checked}
        onChange={handleChange}
        disabled={props.disabled}
        defaultChecked={props.defaultChecked || false}
      />
      <label
        htmlFor={props.id}
        className={`checkbox__label ${props.labelClassName || ''}`}
      >
        {props.label}
      </label>
    </div>
  );
};

export default CheckBox;
